import React, { Component } from 'react';
import './NavigationMenu.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

class NavigationMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonAIsHovering: false,
      buttonBIsHovering: false,
      buttonCIsHovering: false,
      buttonDIsHovering: false,
    };
  }

  handleHoverChange(button) {
    return () => {
      this.setState((prevState) => ({
        [button]: !prevState[button],
      }));
    };
  }

  

  render() {
    const { buttonAIsHovering, buttonBIsHovering, buttonCIsHovering, buttonDIsHovering } = this.state;
    const { handleClick } = this.props;

   

    return (
      <div className="navigation-menu">
        <ul>
          <li>
            <Link
              to="/cv"
              className="hover-underline-animation"
              onMouseEnter={this.handleHoverChange('buttonAIsHovering')}
              onMouseLeave={this.handleHoverChange('buttonAIsHovering')}
              onClick={handleClick}
            >
              {buttonAIsHovering ? 'CURRICULUM VITAE' : 'EXPERTISE'}
            </Link>
          </li>
          <li>
            <Link
              to="/work"
              className="hover-underline-animation"
              onMouseEnter={this.handleHoverChange('buttonBIsHovering')}
              onMouseLeave={this.handleHoverChange('buttonBIsHovering')}
              onClick={handleClick}
            >
              {buttonBIsHovering ? 'PORTFOLIO' : 'WORK'}
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className="hover-underline-animation"
              onMouseEnter={this.handleHoverChange('buttonCIsHovering')}
              onMouseLeave={this.handleHoverChange('buttonCIsHovering')}
              onClick={handleClick}
            >
              {buttonCIsHovering ? 'JEFF' : 'ABOUT'}
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className="hover-underline-animation"
              onMouseEnter={this.handleHoverChange('buttonDIsHovering')}
              onMouseLeave={this.handleHoverChange('buttonDIsHovering')}
              onClick={handleClick}
            >
              {buttonDIsHovering ? "IT" + "'" + "LL BE AWESOME" : 'REACH OUT'}
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}

export default NavigationMenu;
